// extracted by mini-css-extract-plugin
export default {"emptyPage":"styles_emptyPage__azg4H","image":"styles_image__AWer2","title":"styles_title__pRKvC"};